export enum enumUserRole {
    ADMINISTRATOR = 1,
    UTENTE = 2,
    TOURLEADER = 3,
    TOURLEADER_PRO = 4,
}